import React, { useState } from "react";

interface CpTagProps {
  children: React.ReactNode;
  selected?: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
}

/** Filter pill (CertainPath Design System `Tag`). */
const CpTag: React.FC<CpTagProps> = ({
  children,
  selected = false,
  onClick,
  style,
}) => {
  const [hover, setHover] = useState(false);
  const clickable = !!onClick;
  return (
    <button
      aria-pressed={clickable ? selected : undefined}
      disabled={!clickable}
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        padding: "9px 18px",
        borderRadius: "var(--radius-pill)",
        fontFamily: "var(--font-sans)",
        fontSize: "var(--text-body-sm)",
        fontWeight: 600,
        lineHeight: 1.2,
        cursor: clickable ? "pointer" : "default",
        transition: "var(--transition-control)",
        border: `1px solid ${selected ? "var(--ink-500)" : "var(--border-strong)"}`,
        background: selected
          ? "var(--ink-500)"
          : hover && clickable
            ? "var(--sand-200)"
            : "transparent",
        color: selected ? "var(--cream-100)" : "var(--ink-500)",
        ...style,
      }}
      type="button"
    >
      {children}
    </button>
  );
};

export default CpTag;
